import BaseRepository from './BaseRepository';

export default class ExternalRewardsRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'services/external-rewards';
    }

    setPendingEnrollment(data)
    {
        return this.request('POST', `v1/${this.getEndpoint()}/set-pending-enrollment/${data.id}?type=${data.external_reward_type}`, data);
    }
}
